// components/Provider.jsx
'use client'
import { SessionProvider } from 'next-auth/react'
import { UserProvider } from '@context/UserContext'

// `session` comes from the root layout so the first render already knows
// whether the user is logged in (no "Log in" flash for signed-in users).
export default function Provider({ children, session }) {
  return (
    <SessionProvider session={session}>
      <UserProvider>{children}</UserProvider>
    </SessionProvider>
  )
}